<template>
  <div class="all-series">
    <div class="top-section">
      <h1>{{ category.label }}</h1>
      <select-series-style
        v-on:select-style="setSelectedStyle"
      ></select-series-style>
    </div>
    <div class="container">
      <div class="columns saved-items-filter">
        <div>
          <a :class="cls(1)" href="#" @click.prevent="setSelected(1)">סדרות</a>
        </div>
        <div>
          <a :class="cls(2)" href="#" @click.prevent="setSelected(2)"
            >תוכניות אימונים</a
          >
        </div>
      </div>
      <transition name="series" v-if="selected === 1">
        <collection-list :items="itemsToShow"></collection-list>
      </transition>
      <transition name="series" v-else>
        <group-videos :items="itemsToShow"></group-videos>
      </transition>
    </div>
  </div>
</template>

<script>
import CollectionList from "@/components/series/CollectionList.vue";
import GroupVideos from "@/components/series/GroupVideos.vue";
import SelectSeriesStyle from "@/components/series/selectSeriesStyle.vue";

export default {
  components: {
    CollectionList,
    GroupVideos,
    SelectSeriesStyle,
  },
  data() {
    return {
      selected: 1,
      selectedStyle: "0",
    };
  },
  computed: {
    category() {
      const cat = this.$store.state.initialData.seriesCategories.filter(
        c => c.MIGX_id === this.$route.params.catid
      );
      return cat[0];
    },
    categorySeries() {
      const series = this.$store.state.series.filter(s =>
        s.seriesCategory.split("||").includes(`${this.category.MIGX_id}`)
      );
      this.addStyles(series);
      return series;
    },
    itemsToShow() {
      let items = this.categorySeries.filter(s => {
        if (s.parent === "10" && this.selected === 2) {
          return true;
        }

        if (s.parent !== "10" && this.selected === 1) {
          return true;
        }
        return false;
      });

      if (this.selectedStyle === "0") {
        return items;
      } else {
        // sort by style
        return items.filter(s => s.styles.includes(this.selectedStyle));
      }
    },
  },
  methods: {
    cls(selected) {
      if (selected == this.selected) {
        return "saved-filter-item active";
      }
      return "saved-filter-item";
    },
    setSelected(selected) {
      this.selected = selected;
    },
    setSelectedStyle(event) {
      this.selectedStyle = event;
    },
    addStyles(list) {
      list.forEach(series => {
        const styles = this.$store.state.videos
          .filter(v => series.videoItems.split("||").includes(`${v.id}`))
          .map(s => s.current);

        series.styles = styles;
      });
    },
  },
};
</script>

<style>
</style>